<script src="../../../../../../../mq/index.js"></script>
<template>
    <div style="height: 100%;width: 100%">
      <div style="height: 10px"></div>
      <div style="margin: 0 40px">
<!--        <div style="height: 20px"></div>-->
        <el-row style="text-align: center;font-size: 14px;color: white">
          <el-col :span="8">
            <span>服务总次数</span>
          </el-col>
          <el-col :span="8">
            <span>报警总数</span>
          </el-col>
          <el-col :span="8">
            <span>呼入总数</span>
          </el-col>
        </el-row>
        <el-row style="font-family: letisgoDigital;font-size: 24px">
          <el-col :span="8">
            <div class="list-top1">
              <span>{{servicescount}}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="list-top2">
              <span>{{alarmcount}}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="list-top3">
              <span>{{phoneincount}}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="height: 10px"></div>
      <div style="margin: 0 40px">
        <!--        <div style="height: 20px"></div>-->
        <el-row style="text-align: center;font-size: 14px;color: white">
          <el-col :span="8">
            <span>关爱总数</span>
          </el-col>
          <el-col :span="8">
            <span>回访总数</span>
          </el-col>
          <el-col :span="8">
            <span>咨询总次数</span>
          </el-col>
        </el-row>
        <el-row style="font-family: letisgoDigital;font-size: 24px">
          <el-col :span="8">
            <div class="list-top4">
              <span>{{carecount}}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="list-top5">
              <span>{{phonecallcount }}</span>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="list-top6">
              <span>{{lawerservicecount}}</span>
            </div>
          </el-col>
        </el-row>
      </div>
      <div style="margin-top: 15px">
        <div v-if="listData.length === 0" class="no-alarm"></div>
        <div v-if="listData.length === 0" class="no-alarm1">
          <span>暂无报警信息</span>
        </div>
        <el-row>
          <el-col :span="8" v-for="item in listData" :key="item.index">
            <div class="list-top-info">
              <div class="left-img">
                <span v-if="item.pid !== 0">
                  <span v-if="item.person !== ''">
                    <img v-if="item.person.photourl !== ''" :src="item.person.photourl">
                    <img v-else src="../../../assets/SHscreen/index_information_people_head.png">
                  </span>
                  <img v-else src="../../../assets/SHscreen/index_information_people_head.png">
                </span>
                <img v-else src="../../../assets/SHscreen/index_information_home_head.png">
              </div>
              <div class="right-info">
                <div style="height: 3px"></div>
                <div style="height: 18px">
                  <div class="icon-left">
                    <img src="../../../assets/SHscreen/index_information_icon_police.png">
                  </div>
                  <div class="text-right">
                    <span>{{getAlarmType(item.alarmtype)}}</span>
                  </div>
                </div>
                <div style="height: 18px" v-if="item.pid !== 0">
                  <div class="icon-left">
                    <img src="../../../assets/SHscreen/index_information_icon_name.png">
                  </div>
                  <div class="text-right" :title="item.person.name">
                    <span>{{item.person.name}}</span>
                  </div>
                </div>
                <div style="height: 18px">
                  <div class="icon-left">
                    <img src="../../../assets/SHscreen/index_information_icon_phone.png">
                  </div>
                  <div class="text-right" :title="item.phone">
                    <span>{{item.phone}}</span>
                  </div>
                </div>
                <div style="height: 18px">
                  <div class="icon-left">
                    <img src="../../../assets/SHscreen/index_information_icon_address.png">
                  </div>
                  <div v-if="item.pid === 0" class="text-right" :title="item.homeaddress">
                    <span>{{item.homeaddress}}</span>
                  </div>
                  <div v-else class="text-right" :title="item.person.homeaddress">
                    <span>{{item.person.homeaddress}}</span>
                  </div>
                </div>
                <div v-if="item.pid === 0" style="height: 18px">
                  <div class="icon-left">
                    <img src="../../../assets/SHscreen/index_information_icon_home.png">
                  </div>
                  <div class="text-right" :title="item.home_install_location">
                    <span>{{item.home_install_location}}</span>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
</template>

<script>
export default {
  name: 'indexCenterTop',
  props: {
    topObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      servicescount: 0,
      alarmcount: 0,
      phoneincount: 0,
      carecount: 0,
      phonecallcount: 0,
      lawerservicecount: 0,
      listData: []
    }
  },
  created () {
    // console.log(1111, this.topObj)
    this.golobleObject.getNewAlarm = this.getAlarmNew
    this.golobleObject.getMqttAddCnt = this.addCnt
    // this.listData = this.topObj.dataviewalarms.slice(0, 3)
    // console.log(1111, this.listData)
    this.servicescount = this.topObj.dataviewcount.servicescount
    this.alarmcount = this.topObj.dataviewcount.alarmcount
    this.phoneincount = this.topObj.dataviewcount.phoneincount
    this.carecount = this.topObj.dataviewcount.carecount
    this.phonecallcount = this.topObj.dataviewcount.phonecallcount
    this.lawerservicecount = this.topObj.dataviewcount.lawerservicecount
  },
  methods: {
    addCnt (obj) {
      // console.log('top', 111)
      this.alarmcount += 1
      if (obj.alarmtype === 'phonein') {
        this.phoneincount += 1
      }
    },
    getAlarmCount (topObj) {
      this.servicescount = topObj.dataviewcount.servicescount
      this.alarmcount = topObj.dataviewcount.alarmcount
      this.phoneincount = topObj.dataviewcount.phoneincount
      this.carecount = topObj.dataviewcount.carecount
      this.phonecallcount = topObj.dataviewcount.phonecallcount
      this.lawerservicecount = topObj.dataviewcount.lawerservicecount
      // console.log('topObj', topObj)
    },
    getAlarmNew (arr) {
      // console.log('top', arr)
      this.listData = arr.slice(0, 3)
      // console.log('top', this.listData)
    },
    getAlarmType (atype) {
      // console.log(222, atype)
      return this.commonType.getAlarmType(atype)
    }
  }
}
</script>

<style scoped>
.list-top1{
  width: 135px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  margin: -5px auto;
  background: url("../../../assets/SHscreen/index_center_up_1.png");
  background-size: 100% 100%;
  color: #ff9159;
}
.list-top2{
  width: 135px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  margin: -5px auto;
  background: url("../../../assets/SHscreen/index_center_up_2.png");
  background-size: 100% 100%;
  color: #59ffff;
}
.list-top3{
  width: 135px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  margin: -5px auto;
  background: url("../../../assets/SHscreen/index_center_up_3.png");
  background-size: 100% 100%;
  color: #59ff59;
}
.list-top4{
  width: 135px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  margin: -5px auto;
  background: url("../../../assets/SHscreen/index_centre_up_4.png");
  background-size: 100% 100%;
  color: #59c8ff;
}
.list-top5{
  width: 135px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  margin: -5px auto;
  background: url("../../../assets/SHscreen/index_centre_up_5.png");
  background-size: 100% 100%;
  color: #ffe359;
}
.list-top6{
  width: 135px;
  height: 45px;
  line-height: 45px;
  text-align: center;
  margin: -5px auto;
  background: url("../../../assets/SHscreen/index_centre_up_6.png");
  background-size: 100% 100%;
  color: #ff5990;
}
  .list-top-info{
    width: 191px;
    height: 97px;
    margin: auto;
    background: url("../../../assets/SHscreen/index_information_bg.png");
    background-size: 100% 100%;
  }
  .left-img{
    float: left;
    width: 40px;
    margin-top: 10px;
    margin-left: 15px;
    height: 75px;
  }
.left-img img {
  width: 40px;
  height: 50px;
  margin-top: 12px;
}
  .right-info{
    float: left;
    width: 115px;
    margin-top: 10px;
    margin-left: 5px;
    height: 75px;
  }
  .icon-left{
    float: left;
    width: 20px;
    height: 18px;
  }
.icon-left img{
  width: 14px;
  height: 14px;
}
  .text-right{
    font-size: 12px;
    color: white;
    width: calc(100% - 20px);
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: keep-all;
    height: 18px;
  }
  .no-alarm{
    height: 75px;
    width: 120px;
    background: url("../../../assets/SHscreen/index_no_information_img.png");
    background-size: 100% 100%;
    margin: auto;
  }
  .no-alarm1{
    margin-top: 5px;
    height: 20px;
    font-size: 14px;
    color: #00aaff;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/monitoring/bigComponents/indexCenterTop.vue